// src/padplanner/useProjectName.js
//
// The TopNav picker's project, as the PadPlanner pages filter by it (148):
// projectKey ("global" or the id) and projectName (null for the whole
// organization), and the picker's own action to show every project.
import { useProjectStore } from "../stores/useProjectStore";

export function useProjectName() {
  const activeProjectId = useProjectStore((s) => s.activeProjectId);
  const projects = useProjectStore((s) => s.projects);
  const showAll = useProjectStore((s) => s.setActiveProjectId);
  const isGlobal = !activeProjectId || activeProjectId === "global";
  return {
    projectKey: isGlobal ? "global" : activeProjectId,
    projectName: isGlobal ? null : (projects.find((p) => p.id === activeProjectId)?.name ?? "the selected project"),
    showAllProjects: () => showAll("global"),
  };
}
